import { useState } from "react";
import "../css/TabSelector.css";

export function TabSelector({ options, selected, onChange, style }) {
  const [optionSelected, setOptionSelected] = useState(selected);

  return (
    <section className="tab-selector-section">
      {options.map((e, i) => {
        return (
          <div
            key={i}
            className={`tab-selector-container ${
              e === optionSelected ? "tab-selected" : ""
            }`}
            style={style}
            onClick={() => {
              setOptionSelected(e);
              onChange(e);
            }}
          >
            {e}
          </div>
        );
      })}
    </section>
  );
}
